import { UrlConverter, UrlResolver } from '@/background/utils/ipfs/url-resolver'

export const IPFS_URL = 'https://api.universalprofile.cloud/ipfs/' //must end with a slash
export const IPFS_SEARCH = ''
export const ARWEAVE_URL = 'https://arweave.net/'
export const IPFS_CLIENT_URL = 'https://api.universalprofile.cloud/api/v0/add'
export const MSW_RPC_URL = 'https://msw.rpc'
export const FUNCTION_DICTIONARY_URL =
  'https://4bytesdictionary.universalprofile.cloud'

export const urlResolver = new UrlResolver([
  ['ipfs://', new UrlConverter(IPFS_URL)],
  ['ar://', new UrlConverter(ARWEAVE_URL)],
])
